import React from "react";
import { Image, View, Text, ImageBackground, Platform } from "react-native";

import Centered from "../../../../shared/Centered";
import { BGTimerWrapper, BGCollectBtnWrapper } from "../../../../assets";
import { inset } from "../../../../utils/helpers/css";
import { bonusGamesModalStyles } from "./styles";

export interface IPlatformUIProps {
  isSmall: boolean;
  containerScale: number;
  /** Optional; used on native for smallContainerStyle when provided */
  width?: number;
  isDesktop?: boolean;
}

export function getPlatformUI({
  isSmall,
  containerScale,
  width,
  isDesktop,
}: IPlatformUIProps) {
  const isWeb = Platform.OS === "web";
  const smallContainerStyle = isDesktop
    ? { width: 390 }
    : { width: width !== undefined ? width * 0.9 : ("90%" as const) };

  return {
    modalProps: isWeb
      ? {
          closeButtonSize: "big" as const,
          closeButtonStyles: {
            ...bonusGamesModalStyles.buttons,
            top: -23,
            right: isSmall ? -2 : 20,
            transform: [{ scale: isSmall ? 1.4 : 1 }],
          },
          containerStyles: {
            maxWidth: undefined,
            marginTop: isSmall ? 30 : 60,
            transform: [{ scale: isSmall ? 1 : containerScale }],
          },
          contentWrapperStyles: isSmall ? { paddingHorizontal: 0 } : undefined,
        }
      : {
          closeButtonSize: "big" as const,
          closeButtonStyles: {
            ...bonusGamesModalStyles.buttons,
            top: -23,
            right: isSmall ? -2 : 20,
            transform: [{ scale: isSmall ? 1.4 : 1 }],
          },
          containerStyles: {
            maxWidth: undefined,
            marginTop: isSmall ? 30 : 60,
            transform: [{ scale: isSmall ? 1 : containerScale }],
          },
          contentWrapperStyles: isSmall
            ? { paddingHorizontal: 0, width: "100%" as const }
            : undefined,
        },

    smallContainerStyle,

    renderSmallTimer: ({ timeText }: { timeText: string }) =>
      isWeb ? (
        <ImageBackground
          source={BGCollectBtnWrapper}
          style={{
            width: 100,
            // height: 58,
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 6,
          }}
        >
          <View style={{ alignItems: "center", justifyContent: "center" }}>
            <View
              style={{
                width: 125,
                height: 30,
                position: "relative",
                paddingRight: 2,
                marginTop: 4,
              }}
            >
              <Image
                source={BGTimerWrapper}
                style={{ width: 120, height: 40 }}
              />
              <Centered style={{ ...inset(0), position: "absolute", top: 10 }}>
                <Text
                  style={{
                    color: "white",
                    fontWeight: "900",
                    fontSize: 13,
                    width: 120,
                    height: 20,
                    textAlign: "center",
                  }}
                  numberOfLines={1}
                  ellipsizeMode="tail"
                >
                  {timeText}
                </Text>
              </Centered>
            </View>
          </View>
        </ImageBackground>
      ) : (
        <View
          style={
            isSmall
              ? {
                  ...bonusGamesModalStyles.container,
                  ...smallContainerStyle,
                }
              : bonusGamesModalStyles.container
          }
        >
          <ImageBackground
            source={BGCollectBtnWrapper}
            style={{
              width: width !== undefined ? width * 0.28 : 200,
              height: 30,
              position: "relative",
              alignSelf: "center",
            }}
          >
            <View
              style={{
                width: "100%",
                height: 20,
                position: "relative",
                paddingRight: 2,
                marginBottom: 2,
                marginTop: isSmall ? 2 : 20,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ImageBackground
                source={BGTimerWrapper}
                style={{
                  height: 40,
                  width: width !== undefined ? width * 0.22 : 200,
                }}
              >
                <Centered style={{ ...inset(0), position: "absolute" }}>
                  <Text
                    style={{
                      color: "white",
                      fontWeight: "900",
                      fontSize: 14,
                      width: 120,
                      textAlign: "center",
                    }}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    {timeText}
                  </Text>
                </Centered>
              </ImageBackground>
            </View>
          </ImageBackground>
        </View>
      ),
  };
}
